import { useEffect, useState } from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { useAuthentication } from "../../services/authentication/authentication.context";

export const Restricted = () => {

    const { token } = useAuthentication();
    const navigateTo = useNavigate();

    const [denied, setDenied] = useState(false);

    const access_token = new URLSearchParams(window.location.search).get('token');


    useEffect(() => {
      const deny  = setTimeout(() => { setDenied(true) }, 2000)
      if (token === access_token)  navigateTo(`/admin`, { state: process.env.REACT_APP_AUTH });
      return () => clearTimeout(deny);
    }, [access_token, token]);

    return (
        <div className={classNames("f-pg",'flx-c')}>
            {access_token !== token &&
            <div>
                <h1>Error 503</h1>
                <h3>Access Denied</h3>
            </div>
            }
        </div>
    );
}